import { useState } from "react";
import axios from "axios";
import { getApiBase } from "../utils/config";
import "./ResetPasswordModal.css";

const API_BASE = getApiBase();

export default function ResetPasswordModal({ open, onClose, notify }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  if (!open) return null;

  const submit = async () => {
    if (!currentPassword || !newPassword) {
      notify?.("Current password and new password are required", "warning");
      return;
    }
    if (newPassword !== confirmPassword) {
      notify?.("New password and confirm password do not match", "warning");
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("token") || "";
      const res = await axios.post(
        `${API_BASE}/auth/change-password`,
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      notify?.(res?.data?.message || "Password updated", "success");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      onClose?.();
    } catch (e) {
      console.error(e);
      notify?.(e?.response?.data?.message || e.message || "Failed to update password", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div onClick={onClose} className="reset-modal-overlay">
      <div onClick={(e) => e.stopPropagation()} className="reset-modal-content">
        <div className="reset-modal-header">
          <h3 className="reset-modal-title">Reset Password</h3>
          <button type="button" onClick={onClose} className="reset-modal-close-btn">
            Close
          </button>
        </div>

        <div className="reset-modal-form">
          <div className="reset-modal-field">
            <label className="reset-modal-label">Current Password</label>
            <div className="reset-modal-input-wrap">
              <input
                type={show ? "text" : "password"}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="reset-modal-input"
                placeholder="Enter current password"
              />
            </div>
          </div>

          <div className="reset-modal-field">
            <label className="reset-modal-label">New Password</label>
            <div className="reset-modal-input-wrap">
              <input
                type={show ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="reset-modal-input"
                placeholder="Enter new password"
              />
            </div>
          </div>

          <div className="reset-modal-field">
            <label className="reset-modal-label">Confirm New Password</label>
            <div className="reset-modal-input-wrap">
              <input
                type={show ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="reset-modal-input"
                placeholder="Confirm new password"
              />
            </div>
          </div>

          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#374151" }}>
            <input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} />
            Show passwords
          </label>
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
          <button
            type="button"
            onClick={submit}
            disabled={loading}
            className="reset-modal-submit-btn"
          >
            {loading ? "Updating..." : "Update Password"}
          </button>
        </div>
      </div>
    </div>
  );
}


